import { AxiosError } from 'axios';

import { VenueDateBasic } from '@/domain/project-venue-dates/entities/project-venue-dates.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  apiToken: string;
  startDate: string;
  endDate: string;
};

type Result = VenueDateBasic[];

export const importVenueDatesFromOrfeo = createAppAsyncThunk(
  'projectVenueDates/importVenueDatesFromOrfeo',
  async (
    params: Params,
    { extra: { projectVenueDatesGateway, snackbarGateway } },
  ): Promise<Result> => {
    let importedDates: VenueDateBasic[];
    try {
      importedDates = await projectVenueDatesGateway.importDatesFromOrfeo(
        params.apiToken,
        params.startDate,
        params.endDate,
      );
    } catch (error) {
      const axiosError = error as AxiosError<{ name: string }>;
      if (axiosError?.response?.data?.name === 'OrfeoBadTokenException') {
        showSnackbarBadTokenError(snackbarGateway);
        throw error;
      }
      showSnackbarError(snackbarGateway);
      throw error;
    }
    return importedDates;
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('ImportVenueDates.Message.error'));
}

function showSnackbarBadTokenError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(
    translate('ImportVenueDatesOrfeo.Message.bad-token-error'),
  );
}
